<template>
  <div>
    <div class="row review-component">
      <b-card class="col-lg-12 main-content">
        <div class="panel-list" v-show="ClientRequest != null">
          <div class="panel-body">
            <b-row class="panel-title">
              <label :class="'col-'+ColumnsClass">Client Info</label>
            </b-row>
            <b-row class="panel-content">
              <b-col :cols="ColumnsClass">
                <label>HFM Client</label>
                <p>{{ ClientRequest.HFMClientName }}</p>
              </b-col>
              <!-- <b-col :cols="ColumnsClass">
                <label>MDM Client Name</label>
                <p>{{ ClientRequest.MDMClientName }}</p>
              </b-col> -->
              <b-col :cols="ColumnsClass">
                <label>Entity</label>
                <p>{{ ClientRequest.Entity }}</p>
              </b-col>
              <b-col :cols="ColumnsClass">
                <label>Agency</label>
                <p>{{ ClientRequest.Agency }}</p>
              </b-col>
              <b-col :cols="ColumnsClass">
                <label>Client Name</label>
                <p>{{ ClientRequest.ClientName }}</p>
              </b-col>
              <!-- <b-col :cols="ColumnsClass" v-if="IsTruncatedClientActivated">
                <label>Truncated Client Name</label>
                <p>{{ ClientRequest.TruncatedClientName }}</p>
              </b-col> -->
              <b-col :cols="ColumnsClass">
                <label>Requested Client Code</label>
                <p>{{ ClientRequest.RequestedClientCode }}</p>
              </b-col>
              <b-col :cols="ColumnsClass">
                <label>Is this for a client code that is already on file that needs to be opened in an additional media?</label>
                <p>{{ ClientRequest.IsExistingClient }}</p>
              </b-col>
              <b-col :cols="ColumnsClass">
                <label>BPM Assigned</label>
                <p>{{ ClientRequest.BPMAssigned }}</p>
              </b-col>
              <b-col :cols="ColumnsClass">
                <label>DDS Accounting Office Code -D365/IGN Location Mapping</label>
                <p>{{ ClientRequest.DDSAccountingOfficeCode }}</p>
              </b-col>
              <b-col :cols="ColumnsClass">
                <label>DDS Media Office - Location Name</label>
                <p>{{ ClientRequest.DDSMediaOfficeCode }}</p>
              </b-col>
              <b-col :cols="ColumnsClass">
                <label>AX Location/Comp - D365/IGN Location Code</label>
                <p>{{ ClientRequest.AXOfficeLocation }}</p>
              </b-col>
              <b-col :cols="ColumnsClass">
                <label>Does this client need to be set up with product or estimate level UDEFs (User Defined Fields)?
                Example - PO Numbers, Cost Center Accounts, GL Accounts, etc.</label>
                <p>{{ ClientRequest.IsUDEFRequired }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-show="ClientRequest.ProductUDF1">
                <label>Product UDEF1</label>
                <p>{{ ClientRequest.ProductUDF1 }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-show="ClientRequest.ProductUDF2">
                <label>Product UDEF2</label>
                <p>{{ ClientRequest.ProductUDF2 }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-show="ClientRequest.EstimateUDF1">
                <label>Estimate UDEF1</label>
                <p>{{ ClientRequest.EstimateUDF1 }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-show="ClientRequest.EstimateUDF2">
                <label>Estimate UDEF2</label>
                <p>{{ ClientRequest.EstimateUDF2 }}</p>
              </b-col>
              <!-- <b-col :cols="ColumnsClass" v-show="true">
                <label>Special Requirement</label>
                <p>{{ ClientRequest.SpecialRequirement }}</p>
              </b-col> -->
            </b-row>
          </div>
          <div class="panel-body">
            <b-row class="panel-title">
              <label :class="'col-'+ColumnsClass">Euler Grade</label>
            </b-row>
            <b-row class="panel-content">
              <b-col :cols="ColumnsClass">
                <label>Do you need to add or update the Euler grade?</label>
                  <p>{{ AddOrUpdateEular }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-if="AddOrUpdateEular">
                <label>IS THE MEDIA SPEND EXPECTED TO EXCEED THE EULER INSURANCE COVERAGE?</label>
                <p>{{ ClientRequest.IsMediaSpendExceedsInsuranceCoverage }}</p>
              </b-col>
              <b-col :cols="ColumnsClass"  v-if="AddOrUpdateEular">
                <label>Euler Grade</label>
                <p v-if="ClientRequest.EulerGrade">{{ ClientRequest.EulerGrade }}</p>
                <p v-else>-</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-if="AddOrUpdateEular && ClientRequest.ApprovalSource!=null">
                <label>Approval Source</label>
                <p>{{ GetEulerApprovalSourceOriginalValue() }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-if="AddOrUpdateEular">
                <label>Client Entity Name Per Agreement</label>
                 <p>{{ ClientRequest.ClientEntityNamePerAgreement }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-if="AddOrUpdateEular">
                <label>Comments</label>
                 <p v-if="ClientRequest.Comments">{{ ClientRequest.Comments }}</p>
                 <p v-else>-</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-if="AddOrUpdateEular">
                <label>Attached File</label>
                <div v-if="AddOrUpdateEular && EulerFilesUploaded && EulerFilesUploaded.length > 0">
                   <div v-for="file in FilesUploaded('EulerFiles')" :key="file.Name">
                  <span v-if="file.FullName">
                    <a
                      class="file-ref"
                      :href="file.Name"
                      @click.prevent="downloadItem(file)"
                      target="_blank"
                      download
                      >{{ file.Name }}</a
                    >
                  </span>
                  <span v-else>
                    <span>{{ file.Name }}</span>
                  </span>
                </div>
                </div>
                <div v-else>-</div>
              </b-col>
            </b-row>
          </div>
          <div class="panel-body">
            <b-row class="panel-title">
              <label :class="'col-'+ColumnsClass">Billing Info</label>
            </b-row>
            <b-row class="panel-content">
              <b-col :cols="ColumnsClass">
                <label>Biiling Party</label>
                <p>{{ ClientRequest.BillingParty }}</p>
              </b-col>
              <b-col :cols="ColumnsClass">
                <label>Bill to Client</label>
                <p>{{ ClientRequest.ClientBillToName }}</p>
              </b-col>
              <b-col :cols="ColumnsClass">
                <label>Country</label>
                <p>{{ ClientRequest.Country }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-show="!IsBillingCountryUSA">
                <label>Address Line 1</label>
                <p>{{ ClientRequest.AddressLine1 }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-show="!IsBillingCountryUSA">
                <label>Address Line 2</label>
                <p>{{ ClientRequest.AddressLine2 }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-show="IsBillingCountryUSA">
                <label>Street Address </label>
                <p>{{ ClientRequest.TruncatedBillingStreetAddress==null ? ClientRequest.ClientBillingStreetAddress :ClientRequest.TruncatedBillingStreetAddress }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-show="IsBillingCountryUSA">
                <label>City</label>
                <p>{{ ClientRequest.City }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-show="IsBillingCountryUSA">
                <label>State</label>
                <p>{{ ClientRequest.State }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-show="IsBillingCountryUSA">
                <label>Zip Code</label>
                <p>{{ ClientRequest.ZipCode }}</p>
              </b-col>
              <b-col :cols="ColumnsClass">
                <label>Currency</label>
                <p>{{ ClientRequest.Currency }}</p>
              </b-col>
              <b-col :cols="ColumnsClass">
                <label>Default Payment Terms</label>
                <p>{{ ClientRequest.DefaultPaymentTerms }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-if="ScreenshotFilesUploaded && ScreenshotFilesUploaded.length > 0">
                <label>Approval Screenshot from Credit Voyager</label>
                  <div v-for="file in ScreenshotFilesUploaded" :key="file.Name">
                  <span v-if="file.FullName">
                    <a
                      class="file-ref"
                      :href="file.Name"
                      @click.prevent="downloadItem(file)"
                      target="_blank"
                      download
                      >{{ file.Name }}</a
                    >
                  </span>
                  <span v-else>
                    <span>{{ file.Name }}</span>
                  </span>
                </div>
              </b-col>
              <b-col :cols="ColumnsClass">
                <label>is this a COS2 Client</label>
                <p>{{ ClientRequest.IsThisCostToClient }}</p>
              </b-col>
               <b-col :cols="ColumnsClass" v-if="ClientRequest.ProgrammaticBundled!=null" >
                <label>is this client COS2 ONLY for media B- Programmatic Bundled </label>
                <p>{{ ClientRequest.ProgrammaticBundled }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-if="ClientRequest.AORClientCode">
                <label>AOR Client Code</label>
                <p>{{ ClientRequest.AORClientCode }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-if="ClientRequest.AORClientName">
                <label>AOR Client Name</label>
                <p>{{ ClientRequest.AORClientName }}</p>
              </b-col>
              <b-col :cols="ColumnsClass" v-if="ClientRequest.AORClientAgency">
                <label>AOR Client Agency</label>
                <p>{{ ClientRequest.AORClientAgency }}</p>
              </b-col>
            </b-row>
          </div>
          <div class="panel-body" v-if="BillingPartyNotTimeOnly">
            <b-row class="panel-title">
              <label class="col-lg-">Commission Info</label>
            </b-row>
            <b-row class="panel-content">
            <b-row class="col-lg-12" v-if="ClientRequest && ClientRequest.ClientMediaCommissions">
              <b-col v-if="IsProductionBilling">
                <p> Production Billing Only </p>
              </b-col>
              <b-col v-else
                cols="lg-4"
                v-for="mediatype in ClientRequest.ClientMediaCommissions"
                :key="mediatype.MediaType + '-' + mediatype.FeeOnly"
              >
               <label>{{ mediatype.MediaType }}</label>

                <div>
                  <div>
                    Fee Only :
                    <span v-if="mediatype.FeeOnly">Yes</span>
                    <span v-else>No</span>
                  </div>

                  <div v-if="!mediatype.FeeOnly">
                    Commission %: {{ mediatype.CommissionPercentage }}%
                  </div>
                  <div v-else>Commission %: -</div>

                  <div v-if="!mediatype.FeeOnly">
                    Commission Basis: {{ mediatype.CommissionBasis }}
                  </div>
                  <div v-else>Commission Basis: -</div>

                  <div v-if="mediatype.DefaultPaymentTerms">
                    Default PaymentTerms: {{ mediatype.DefaultPaymentTerms }}
                  </div>
                </div>
              </b-col>

            </b-row>
            </b-row>
            <b-row class="panel-content" v-if="CreditVoyagerApprovalFilesUploaded && CreditVoyagerApprovalFilesUploaded.length > 0">
                <b-col :cols="ColumnsClass">
                  <label>Were the Payment terms above N030 approved by the Network CFO?</label>
                  <p>true</p>
                </b-col>
                <b-col :cols="ColumnsClass">
                  <label>Credit Voyager Approval for Payment terms</label>
                    <div v-for="file in CreditVoyagerApprovalFilesUploaded" :key="file.Name">
                    <span v-if="file.FullName">
                        <a
                        class="file-ref"
                        :href="file.Name"
                        @click.prevent="downloadItem(file)"
                        target="_blank"
                        download
                        >{{ file.Name }}</a
                      >
                    </span>
                    <span v-else>
                      <span>{{ file.Name }}</span>
                    </span>
                  </div>
                </b-col>
              </b-row>
          </div>
          <div class="panel-body">
            <b-row class="panel-title">
              <label :class="'col-'+ColumnsClass">Product Info</label>
            </b-row>
            <b-row
              class="panel-content row"
              v-if="ClientRequest.ProductDetails"
            >
              <b-col
                cols="lg-4"
                v-for="product in ClientRequest.ProductDetails"
                :key="product.ProductName"
              >
                <label>Product Name: {{ product.ProductName }}</label>
                <div>Product Code: {{ product.ProductCode }}</div>
                <div
                  v-if="
                    product.ProductCommissionDetails != null &&
                    product.ProductCommissionDetails.length > 0
                  "
                >
                  Media:
                  {{
                    product.ProductCommissionDetails.map(
                      (s) => s.MediaType
                    ).join(",")
                  }}
                </div>
                <div v-if="IsProductExceptionsAdded(product)">
                  <div>
                    <!-- Exceptions: -->
                    <div v-html="GetCommissionException(product)"></div>
                    <div v-html="GetBillingException(product)"></div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="panel-body" v-if="ClientRequest.TimeEntryEntities">
            <b-row class="panel-title">
              <label :class="'col-'+ColumnsClass">Time Entry</label>
            </b-row>
            <b-row
              class="panel-content row"
            >
              <b-col
                cols="lg-12">
                <label>The entity selected, where work will be performed against this client or where time will need to be recorded for this client</label>
                <p class="mb-0" v-for="entity in ClientRequest.TimeEntryEntities.split(',').map(item => item.trim())"
                  :key="entity">{{ entity }}</p>
              </b-col>
            </b-row>
          </div>
          <div class="panel-body" v-if="ClientRequest.SpecialRequirement">
            <b-row class="panel-title">
              <label :class="'col-'+ColumnsClass">Special Requirement</label>
            </b-row>
            <b-row
              class="panel-content row"
              v-if="ClientRequest.SpecialRequirement"
            >
              <b-col
                cols="lg-12">
                <label>{{ ClientRequest.SpecialRequirement }}</label>
              </b-col>
            </b-row>
          </div>
          <div class="panel-body" v-if="AdditionalDocuments.length > 0">
            <b-row class="panel-title">
              <label :class="'col-'+ColumnsClass">Additional Documentation</label>
            </b-row>
              <b-col :cols="ColumnsClass" class="p-0" v-if="AdditionalDocuments && AdditionalDocuments.length > 0">
                  <div v-for="file in AdditionalDocuments" :key="file.Name">
                  <span v-if="file.FullName">
                    <a
                      class="file-ref"
                      :href="file.Name"
                      @click.prevent="downloadItem(file)"
                      target="_blank"
                      download
                      >{{ file.Name }}</a
                    >
                  </span>
                  <span v-else>
                    <span>{{ file.Name }}</span>
                  </span>
                </div>
              </b-col>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Overview",
  props: {
    ClientRequest: {
      required: false,
      type: Object,
    },
    DownloadableFiles: {
      type: Boolean,
      required: false,
      default: true,
    },
    ID:{
      type:Number,
      required:false,
      default:0
    },
    Columns:{
      type:Number,
      default:4,
      required:false,
    }
  },
  data() {
    return {
      USACountry: "United States",
      CountryUnitedStatesValue: "78d70193e1eb493dafcf3f261b7759ef",
      Files: [],
      BillingStreetAddressLength:26,
      FilesLoaded:false,
    };
  },
  created(){
      if (this.ID && parseInt(this.ID) > 0 && this.DownloadableFiles && this.FilesLoaded==false) {
        this.FilesLoaded=true;
        this.LoadFiles();
      }
  },
  watch: {
    "ClientRequest.ID": function (val) {
      if (val && parseInt(val) > 0 && this.DownloadableFiles && this.FilesLoaded==false) {
        this.FilesLoaded=true;
        this.LoadFiles();
      }
    },
  },
  computed: {
    IsProductionBilling() {
      return (
        this.ClientRequest &&
        this.ClientRequest.ClientMediaCommissions &&
        this.ClientRequest.ClientMediaCommissions.some(
          item => item.ProductionBilling === true
        )
      );
    },
    ColumnsClass(){
     return `lg-${this.Columns}`;
    },
    BillingPartyNotTimeOnly(){

      let timeOnlyOptions=["Time Only (Client Related Time MED)","Time Only (Internal Project Related Time ADM)"];
      //let timeOnlySelected=timeOnlyOptions.includes(this.BillingInfo.BillingParty);
      return !(this.ClientRequest && timeOnlyOptions.includes(this.ClientRequest.BillingParty));
    },
    AddOrUpdateEular(){
     return this.ClientRequest.AddOrUpdateEular;
    },
    EulerFilesUploaded(){
      return this.FilesUploaded('EulerFiles');
    },
    ScreenshotFilesUploaded(){
      return this.FilesUploaded('ScreenshotFiles');
    },
    AdditionalDocuments(){
      return this.FilesUploaded('AdditionalDocuments');
    },
    CreditVoyagerApprovalFilesUploaded(){
      return this.FilesUploaded('CreditVoyagerApprovalFiles');
    },
    IsBillingCountryUSA() {
      return this.ClientRequest.Country == this.USACountry;
    },
    IsTruncatedClientActivated() {
      return (
        this.ClientRequest != null &&
        this.ClientRequest.TruncatedClientName != null &&
        this.ClientRequest.TruncatedClientName != ""
      );
    },
  },
  methods: {
    async downloadItem(file) {
      this.$store
        .dispatch("client/DownloadFile", file)
        .then((response) => {
          const blob = new Blob([response.data], { type: file.Extension });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = file.Name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((ex) => {
          if (ex.response) {
            this.$store.dispatch(
              "progress/setErrorMessage",
              `Error while downloading file. ${ex.response.data}`
            );
          } else {
            this.$store.dispatch(
              "progress/setErrorMessage",
              `Error while downloading file. ${ex}`
            );
          }
        });
    },
    async LoadFiles() {
      this.$store
        .dispatch("client/RenderUploadedFiles", parseInt(this.ID))
        .then((res) => {
          if (res) {
            this.Files = res.data;
          } else {
            this.Files = [];
          }
        })
        .catch(() => {
          this.$store.dispatch(
            "progress/setErrorMessage",
            "Error while loading uploaded files"
          );
        });
    },
    IsProductExceptionsAdded(product) {
      return (
        product != null &&
        (product.ProductBillingAddress != null ||
          product.CommissionBasisID != null ||
          product.FeeOnly != null ||
          product.TimeOnly != null)
      );
    },

    GetEulerApprovalSourceOriginalValue(){
      if(this.ClientRequest.ApprovalSource =="1")
      {
          return "Network CEO";
      }
      else if(this.ClientRequest.ApprovalSource =="2")
      {
          return "Network CFO";
      }
      else
      {
          return "Omnicom CFO";
      }
    },

    IsBillingExceptionAdded(product) {
      return product != null && product.ProductBillingAddress != null;
    },
    IsCommissionExceptionAdded(product) {
      return (
        product != null &&
        (product.CommissionBasisID != null || product.FeeOnly != null)
      );
    },
    GetCommissionException(product) {
      let html = "";
      if (
        product.CommissionBasisID != null ||
        product.FeeOnly != null ||
        product.TimeOnly != null
      ) {
        if (product.TimeOnly) {
          html += `Time Only`;
        } else if (product.CommissionBasisID == 1) {
          html += `Commission Basis: Net - ${product.CommissionPercentage}%`;
        } else if (product.CommissionBasisID == 2) {
          html += `Commission Basis: Gross - ${product.CommissionPercentage}%`;
        } else if (product.FeeOnly) {
          html += `Fee Only`;
        }
      }
      return html;
    },
    GetBillingException(product) {
      let html = "";
      if (product.ProductBillingAddress != null) {
        if (product.ProductBillingAddress.Country != this.USACountry) {
          html += `Billing Address: ${product.ProductBillingAddress.AddressLine1} ${product.ProductBillingAddress.AddressLine2}`;
        } else {
          let billingAdddress=product.ProductBillingAddress.BillingStreetAddress.length>this.BillingStreetAddressLength &&product.ProductBillingAddress.TruncatedBillingStreetAddress ?product.ProductBillingAddress.TruncatedBillingStreetAddress:product.ProductBillingAddress.BillingStreetAddress;
          html += `Billing Address: ${billingAdddress} <div> ${product.ProductBillingAddress.City},${product.ProductBillingAddress.State},${product.ProductBillingAddress.ZipCode} </div>`;
        }
      }
      return html;
    },
    FilesUploaded(fileCategory) {
      let files = [];
      if (this.DownloadableFiles) {
        this.Files.filter(file => file.Category == fileCategory).forEach((element) => {
          files.push(element);
        });
      } else {
        this.ClientRequest.Files.filter(file => file.Category == fileCategory).forEach((element) => {
          files.push(element);
        });
      }
      return files;
    },
  },
};
</script>

<style scope >
.file-ref {
  color: #007bff !important;
}
.panel-list:not(.media-dropdowns) {
  padding-left: 0;
  padding-right: 0;
}
.panel-list .panel-body .panel-title {
  border-bottom: 1px solid rgba(151, 151, 151, 0.2);
  width: 100%;
  margin-left: 0px;
  margin-bottom: 25px !important;
}
.panel-list .panel-body .panel-title label {
  color: #77a2bb;
  margin-bottom: 0px !important;
  padding-top: 13px !important;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.57;
  letter-spacing: normal;
  padding-left: 0px !important;
  min-height: 35px;
  white-space: nowrap;
}
.panel-list .panel-body .panel-title .btn {
  padding-left: 5px;
  padding-right: 5px;
}
.panel-list .panel-body .panel-title > div {
  padding-right: 0px !important;
  float: right;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.75;
  letter-spacing: normal;
  color: #00a1d2;
}
.panel-list .panel-content label {
  text-transform: uppercase;
  color: #2c3865;
  font-size: 12px;
  margin-bottom: 1px !important;
  padding-left: 0px;
}
.panel-list .panel-content p {
  text-transform: uppercase;
  color: #4d5161;
  font-size: 14px;
}
.panel-content.row > div > label:first-child {
  color: #2c3865 !important;
  font-family: "Open Sans" !important;
  font-size: 12px;
  font-weight: 600 !important;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  word-break: break-word;
}
.panel-content.row > div > *:not(:first-child) {
  font-family: "Open Sans" !important;
  font-size: 14px !important;
}
.panel-content.row > div > div {
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #4d5161;
}
.panel-list > .panel-body {
  margin-top: 1rem !important;
}
.panel-content.row > div {
  margin-bottom: 10px !important;
}
.edit-icon {
  height: 11px;
  width: 11px;
  color: #00a1d2;
}
.request-status {
  background-color: rgba(216, 216, 216, 0.2);
  margin-left: 1rem;
  margin-right: 1rem;
  display: flex;
  height: 135px;
  border-radius: 5px;
}
.status-bar {
  line-height: 2;
  color: #d5d7e0;
}
.request-status .status {
  font-size: 12px;
  font-family: "Open Sans";
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #4d5161;
}
.request-status .date {
  font-size: 10px;
  font-family: "Open Sans";
  font-weight: regular;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #a2a9ad;
}
.request-status .updatedby {
  font-size: 10px;
  font-family: "Open Sans";
  font-weight: regular;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #4d5161;
}
.request-status .comments {
  font-size: 12px;
  font-family: "Open Sans";
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #00a1d2;
}
</style>